import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const initI18Nexeus = async (supportedLanguages: string[]) => {
  const apiKey = "vPCfaww4kzPRNBo3JzzksA";
  const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

  // Clarification about webapp :
  // fallbackLng is "en" by default, the english lanugae will set as default language
  // if the user login, we will change the language using his profile languageId
  // if his languageId is inside supportedLanguages, the app will translated to that language.
  // if not the app will keep translations to "en"
  i18next
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
      compatibilityJSON: "v3",
      // fallbackLng: Language to use if translations in user language are not available.
      // translations must be supported by the fallback
      fallbackLng: "en",
      ns: ["default"],
      defaultNS: "default",
      supportedLngs: supportedLanguages,
      backend: {
        loadPath,
      },
    });
};

export const changeLanguage = (lng: string) => {
  // if the lng isn't exist inside the supportedLanguages
  // the i18next will use the fallback language ("en") and will change the webapp language to english
  i18next.changeLanguage(lng);
};

export const getLanguage = () => {
  // if the i18next.language isn't exist inside the supportedLanguages, we have to return the fallback one "en"
  const supportedLngs = i18next.options.supportedLngs as readonly string[];
  const currentLanguage = i18next.language;
  if (supportedLngs.includes(currentLanguage)) {
    return currentLanguage;
  } else {
    return "en";
  }
};
